import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { helpHttp } from "../../helpers/helpHttp";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BASE_API, LABELTEXT } from "../../api/Globals";
import { Image } from "primereact/image";
import { storage } from "../../helpers/storage";

const FolioConsulta = (
    {
        rowData = [],
        onHide = () => { }
    }
) => {

    const [folioDialog, setFolioDialog] = useState(false);
    const [dataFolio, setDataFolio] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [loading1, setLoading1] = useState(false);

    const usuario = storage.get('usuario')
    const ciclo = storage.get('ciclo')

    useEffect(() => {
        if (rowData.length !== 0) {
            const url = (`${BASE_API}Tablets/postSpdAlmObtenerTabletsXFolioMov`);
            console.log(rowData)
            helpHttp().post(url, {
                body: {
                    idUsuario: storage.get('id'),
                    idEstatus: rowData.IdEstatus,
                    FolioMov: rowData.FolioTransferencia,
                    parametrosExtra: ""
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCES !== false) {
                    setFolioDialog(true);
                    setDataFolio(res.ITEMS);
                    console.log(res.ITEMS)
                }
            })
        }
    }, [rowData]);

    useEffect(() => {
        if (rowData.length !== 0) {
            if (rowData.TieneAdjunto === 1) {
                helpHttp().post(`${BASE_API}Tablets/postSpdAlmObtenerDocumentoFolio`, {
                    body: {
                        Folio: rowData.FolioTransferencia,
                        ParametroExtras: ""
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if(res.SUCESS !== false){
                        console.log(res.ITEMS)
                        setImagenes(res.ITEMS)
                    }
                })
            }
        }
    }, [rowData])

    const onHideFolio = () => {
        setFolioDialog(!folioDialog);
        onHide();
    }

    const obtenerReporte = () => {
        setLoading1(true)
        const url = (`${BASE_API}Reportes/postObtenerReporte`);
        helpHttp().post(url, {
            body: {
                reporte: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? 11 : 2,
                idUsuario: storage.get('id'),
                Folio: rowData.FolioTransferencia,
                parametrosExtra: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS !== false) {
                const date = new Date()
                var temp = 'data:application/pdf;base64,'
                    + encodeURIComponent(res.ITEMS);
                var download = document.createElement('a')
                download.href = temp
                download.download = (`${usuario}_${date.toLocaleString('en-GB').slice(0,10)}_Ciclo_${ciclo.Descripcion}`)
                document.body.appendChild(download)
                download.click()
                document.body.removeChild(download)
                setLoading1(false)
            }
        })
    }

    const ObtenerFolio = async () => {
        const images = await helpHttp().post(`${BASE_API}Tablets/postSpdAlmObtenerDocumentoFolio`, {
            body: {
                Folio: rowData.FolioTransferencia,
                ParametroExtras: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS !== false) {
                return res.ITEMS
            }
        })

        // return (
        //     <>
        //         {images.map(e => {
        //             return <Image src={e.Ruta} alt="Image" width="250" preview />
        //         })}
        //     </>
        // )
    }

    const tabletDialogFooter = (
        <React.Fragment>
            <Button label="Cerrar" disabled={loading1} icon="pi pi-times" className="p-button-outlined" onClick={() => onHideFolio()} />
            <Button label="Imprimir" loading={loading1} icon="pi pi-print" className="p-button" onClick={() => obtenerReporte()} />
        </React.Fragment>
    );

    const fechaTemplate = (item) => {

        const date = new Date(item.fecha);

        return <label>{date.toLocaleDateString('en-GB')}</label>
    }

    const FormatCellDrop = (option) => {
        return (
            <label>{option.Estatus}</label>
        )
    }

    const bodySerieTemplate = (rowData) => {
        const label = parseInt(process.env.REACT_APP_SISTEMA) === 1 ? rowData.serie : rowData.serie.slice(5, rowData.serie.length)
        return <label>{label}</label>
    }

    return (
        <Dialog visible={folioDialog} style={{ width: '35% ' }} draggable={false} onHide={onHideFolio} closable={false} header="FOLIO DE TRANSACCIÓN" footer={tabletDialogFooter}>
            <div className="grid text-center">
                {dataFolio.length !== 0 && rowData.length !== 0 &&
                    <div className="col-12 text-xl flex-auto m-3">
                        <label className="font-bold">Destino:&nbsp;</label><label>{rowData.TIenda_Destino}</label><br />
                        <label className="font-bold">Fecha último movimiento:&nbsp;</label>{fechaTemplate(dataFolio[0])}<br />
                        <label className="font-bold">Estatus:&nbsp;</label>{FormatCellDrop(dataFolio[0])}<br />
                        <label className="font-bold">Observaciones:&nbsp;</label><label>{dataFolio[0].Observaciones}</label><br />
                        {rowData.TieneAdjunto === 1 && imagenes.length !== 0 &&
                            <div className="mt-5 grid">
                                <div className="col-12 mb-3"><label className="font-bold">Imagenes adjuntas:</label></div>
                                {imagenes.map((image, index) => {
                                    return <Image key={index} src={image.Imagen} alt="Image" width="100" preview style={{ marginLeft: '1em'}} />
                                })}
                            </div>}
                        <div className="mt-5">
                            <label className="font-bold mb-3">{`${LABELTEXT} adjuntas`}</label><br />
                            <DataTable value={dataFolio} showGridlines size="small"
                            paginator rows={20} rowsPerPageOptions={[20, 50, 100]}
                            currentPageReportTemplate="Mostrando {first} hasta {last} de {totalRecords}">
                                <Column field="Prenda" header='Prenda' alignHeader={'center'} style={{ textAlign: 'left'}} />
                                <Column field="Talla" header='Talla' alignHeader={'center'} style={{ textAlign: 'center'}} />
                                <Column field="serie" body={bodySerieTemplate} header='No. de serie' alignHeader={'center'} style={{ textAlign: 'center'}} />
                            </DataTable>
                        </div>
                    </div>}
            </div>
        </Dialog>
    )
}

export default FolioConsulta;